import { Link } from "react-router-dom";

const LINKS = [
  { to: "/aide", label: "Aide" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
  { to: "/legal/cgu", label: "CGU / CGV" },
  { to: "/legal/confidentialite", label: "Confidentialité" },
  { to: "/legal/mentions-legales", label: "Mentions légales" },
];

export function Footer() {
  return (
    <footer className="border-t border-zinc-900 mt-auto" data-testid="app-footer">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <nav className="flex flex-wrap gap-x-6 gap-y-2 justify-center mb-4">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-link-${l.to.replace(/\//g, "-").replace(/^-/, "")}`}
              className="text-xs text-zinc-500 hover:text-amber-400 transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <p className="text-center text-xs text-zinc-600">
          © {new Date().getFullYear()} Cehnura. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
}

export function FooterLinks() {
  return (
    <nav className="flex flex-wrap gap-x-4 gap-y-1 justify-center mt-6" data-testid="footer-links-inline">
      {LINKS.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          className="text-xs text-zinc-600 hover:text-amber-400 transition-colors"
        >
          {l.label}
        </Link>
      ))}
    </nav>
  );
}
